import Vue from 'vue'

const resource = 'master-data'

const get = () => Vue.axios.get(`${resource}`)
const getResolutions = () => Vue.axios.get(`${resource}/resolutions`)

export default {
  get,
  getResolutions
}



// WEBPACK FOOTER //
// ./src/api/master.js